import React from 'react';
import Button from '../../../components/ui/Button';

const VenueList = ({ venues, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="p-6">
        <div className="space-y-4">
          {[...Array(5)]?.map((_, index) => (
            <div key={index} className="animate-pulse">
              <div className="bg-muted rounded-lg p-4">
                <div className="h-4 bg-muted-foreground/20 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-muted-foreground/20 rounded w-1/2 mb-2"></div>
                <div className="h-3 bg-muted-foreground/20 rounded w-2/3"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (venues?.length === 0) {
    return (
      <div className="p-6 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl text-muted-foreground">🏢</span>
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">No Venues Found</h3>
        <p className="text-sm text-muted-foreground">
          Start by creating your first venue or adjust your search filters
        </p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="space-y-4">
        {venues?.map((venue) => (
          <div key={venue?.id} className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-medium text-foreground mb-1">
                  {venue?.name}
                </h3>
                <div className="space-y-1 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <span>📍</span>
                    <span>
                      {venue?.address_line_1}
                      {venue?.address_line_2 && `, ${venue?.address_line_2}`}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>🏙️</span>
                    <span>{venue?.city}, {venue?.state} {venue?.postal_code}</span>
                  </div>
                  {venue?.capacity && (
                    <div className="flex items-center gap-2">
                      <span>👥</span>
                      <span>Capacity: {venue?.capacity?.toLocaleString()}</span>
                    </div>
                  )}
                  {venue?.contact_phone && (
                    <div className="flex items-center gap-2">
                      <span>📞</span>
                      <span>{venue?.contact_phone}</span>
                    </div>
                  )}
                  {venue?.amenities?.length > 0 && (
                    <div className="flex items-center gap-2">
                      <span>🏷️</span>
                      <span className="text-xs">
                        {venue?.amenities?.slice(0, 3)?.join(', ')}
                        {venue?.amenities?.length > 3 && ` +${venue?.amenities?.length - 3} more`}
                      </span>
                    </div>
                  )}
                </div>
                {venue?.description && (
                  <p className="mt-2 text-sm text-muted-foreground line-clamp-2">
                    {venue?.description}
                  </p>
                )}
              </div>
              
              <div className="flex flex-col gap-2 ml-4">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onEdit?.(venue)}
                  iconName="Edit"
                >
                  Edit
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onDelete?.(venue?.id)}
                  className="text-red-600 hover:text-red-700 border-red-200 hover:border-red-300"
                >
                  Delete
                </Button>
              </div>
            </div>

            {/* Status indicator */}
            <div className="mt-3 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-xs text-muted-foreground">Active</span>
              </div>
              <span className="text-xs text-muted-foreground">
                Created {new Date(venue?.created_at)?.toLocaleDateString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VenueList;